export const assets = [
  //ZONE 1

  {
    "Asset ID": "ASD-GSE-01CR01-PAC002",
    Description: "AIR COMPRESSOR",
    Level: "5",
    "Machine Health": "Acceptable",
    Group: "AIR COMPRESSOR",
    "Owning Department": "MECHANICAL",
    location: "1",
  },
  {
    "Asset ID": "ASD-GSE-03CR02-PAC003",
    Description: "AIR COMPRESSOR",
    Level: "5",
    "Machine Health": "Acceptable",
    Group: "AIR COMPRESSOR",
    "Owning Department": "MECHANICAL",
    location: "1",
  },
  {
    "Asset ID": "LSD-MWB-01WK13-PAC004",
    Description: "AIR COMPRESSOR",
    "Machine Health": "Acceptable",
    Level: "5",
    Group: "AIR COMPRESSOR",
    "Owning Department": "MV-ELECT",
    location: "1",
  },
];
